import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import *  as $ from 'jquery';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { SheduleService } from "app/main/pagina/productos/certificar/tipo_2/services/shedule.service";
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ChangeDetectorRef } from '@angular/core';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

const moment = require('moment');
const momentTz = require('moment-timezone');
import {FormControl} from '@angular/forms';
import { AuthService } from 'app/auth/auth.service';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { ProgramacionN35Service} from 'app/main/wizard-n35encuestador/services/programacionn35.service';
import { lang_shedule } from 'app/idiomas/i18n/shedule35/shedule35.lang';
import {MatTableDataSource} from '@angular/material/table';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'modal-reco',
  templateUrl: './modal-reco.component.html',
  styleUrls: ['./modal-reco.component.scss']
})
export class ModalRecoComponent implements OnInit {

  @ViewChild('inputFecha', { read: MatInput }) input: MatInput;
  @ViewChild('recordatorioFechas', { read: undefined }) calReco2: MatDatepicker<Date>;

  idiomaActual:string;
  idiomaActualDatePicker:string;
  filtroRecordatorios: any;
  fechaRecoTemp: any;


  fechas: any[] = [
    {icono: 'send', tipo: "lanzamiento", fecha: "", hora: "", elegida: false, cargando: true, visible: true, elegible: true,visibleInstituto:true},
    {icono: 'power_settings_new', tipo: "cierre", fecha: "", hora: "", elegida: false, cargando: true, visible: true, elegible: false,visibleInstituto:true},
    {icono: 'filter_1', tipo: "aviso1", fecha: "", hora: "", elegida: false, cargando: true, visible: true, elegible: false,visibleInstituto:true},
    {icono: 'filter_2', tipo: "aviso2", fecha: "", hora: "", elegida: false, cargando: true, visible: true, elegible: false,visibleInstituto:true},
  ];
  fechas2: any[] = [
    {icono: 'send', tipo: "lanzamiento", fecha: "",tipoCorreo:1, hora: "", elegida: false, cargando: true, visible: true, elegible: true,visibleInstituto:true},
    {icono: 'power_settings_new', tipo: "cierre", fecha: "",tipoCorreo:6, hora: "", elegida: false, cargando: true, visible: false, elegible: false,visibleInstituto:false},
    // {icono: 'looks_one', tipo: "recor30", fecha: "",tipoCorreo:2, hora: "", elegida: false, cargando: true, visible: false, elegible: false,visibleInstituto:false},
    // {icono: 'looks_two', tipo: "recor29", fecha: "",tipoCorreo:3, hora: "", elegida: false, cargando: true, visible: false, elegible: false,visibleInstituto:false},
    // {icono: 'looks_3', tipo: "recor15", fecha: "",tipoCorreo:4, hora: "", elegida: false, cargando: true, visible: false, elegible: false,visibleInstituto:false},
    // {icono: 'looks_4', tipo: "recor7", fecha: "",tipoCorreo:5, hora: "", elegida: false, cargando: true, visible: false, elegible: false,visibleInstituto:false},
  ];
  iconosAvisos:any[]=[{nombre:'looks_one'},{nombre:'looks_two'},{nombre:'looks_3'},{nombre:'looks_4'}]

  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERROR1',
    'SHEDULE.ERROR2',
    'SHEDULE.ERROR3',
    'SHEDULE.ERROR4',
    'SHEDULE.ERROR5',
    'SHEDULE.MSJ1',
    'SHEDULE.MSJ2',
    'SHEDULE.MSJ3',
    'SHEDULE.MSJ4',
    'SHEDULE.MSJ5',
    'SHEDULE.MSJ6',
    'SHEDULE.MSJ7',
    'SHEDULE.MSJ8',
    'SHEDULE.MSJ9',
    'SHEDULE.MSJ10',
    'SHEDULE.MSJ11',
    'SHEDULE.MSJ12',
    'SHEDULE.MSJ13',
    'SHEDULE.MSJ14',
    'SHEDULE.MSJ15',
    'SHEDULE.SAMEDATE'
  ];
  mensajesTraducirTS = {
    error1: '',
    error2: '',
    error3:'',
    error4:'',
    error5:'',
    msj1:'',
    msj2:'',
    msj3:'',
    msj4:'',
    msj5:'',
    msj6:'',
    msj7:'',
    msj8:'',
    msj9:'',
    msj10:'',
    msj11:'',
    msj12:'',
    msj13:'',
    msj14:'',
    msj15:'',
    error6: ''
  };
  columnas: string[] = ['tipoFecha', 'fechaElegida', 'acciones'];
  origen: number;
  tipoOrigen: any;

  fechaLanza: any;
  fechaCierre: any;

  filtroCalendario: any;
  filtroCalendarioDefault:any

  filtroHoraHoy: any;
  fechaLanzamiento=true;
  idRecordatorio:any;
  recordatoriosPermitidos = 1000;

  filtroLanzamiento = (d: Date | null): boolean => {
    // this.fechaInicialGenerica = new Date(moment().year(), moment().month(), 1);
    let fechaMinima: any;
    if(this.esHoy){
      // console.log("entro el primer caso");
      // console.log("primer fecha::::::::",moment().format('MM/DD/YYYY'));
      // console.log("segunda fecha::::::::",moment(d||new Date()).format('MM/DD/YYYY'));

      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        // console.log("tomo valor 1",moment(d||new Date()).format('YYYY'));
        fechaMinima = moment(d||new Date()).format('MM/DD/YYYY') >= moment().format('MM/DD/YYYY')

      }else{
      // console.log("tomo valor 2",moment(d||new Date()).format('YYYY'));

        fechaMinima = moment(d||new Date()).format('MM/DD/YYYY')
      }
      // console.log("fecha Minima::::::::",fechaMinima);
    }
    else{
      // console.log("entro el segundo caso");
      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        // console.log("tomo valor 1",moment(d||new Date()).format('YYYY'));
      fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
    }else{
      // console.log("tomo valor 2",moment(d||new Date()).format('YYYY'));
      fechaMinima = moment(d || new Date()).format('MM/DD/YYYY')

    }
    }
    return fechaMinima;
  };




  filtroAviso2 = (d: Date | null): boolean => {
    // this.fechaInicialGenerica = new Date(moment(this.fechas[1].fecha).year(), moment(this.fechas[1].fecha).month(), 1);
    const diaInicial = moment(this.fechas[2].fecha);
    const diaFinal = moment(this.fechaLanza).subtract(1,'days');
    const diaActual = moment(d || new Date());
    return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
  };

  filtroCierre = (d: Date | null): boolean => {
    // this.fechaInicialGenerica = new Date(moment(this.fechas[1].fecha).year(), moment(this.fechas[1].fecha).month(), 1);
    // this.fechaInicialGenerica = new Date(2020,11, 1);
    let diaInicial = moment(this.fechas[0].fecha);
    const diaActual = moment(d || new Date());
    return diaActual.isAfter(diaInicial)
  };


  fechaAnterior = "";
  city_name:any;
  //zonas horarias
  zonasUTC = zonasUTC;
  indiceZona: number;
  horaInstituto: any;
  horaInstitutoTag: any;
  esHoy: boolean;
  horaMinima: string;
  diferenciaUtc: number;
  offsetPipe: string;
  fechaInicialGenerica: any;

  banderas: any = {};
  closeNotice:boolean;
  selectNotice1:boolean;
  selectNotice2:boolean;
  nameUserAdmin:any="";
  userData:any;
  nivelNotificacion:number;
  recordatorioBorrado: boolean;
  recordatorioActualizado: boolean;

  // variables NORMA
  labelDate: string = '';
  labelDate2: string = '';
  labelCierre: string = '';
  labelRecordatorio1: string = '';
  labelRecordatorio2: string = '';
  labelRecordatorio3: string = '';
  labelRecordatorio4: string = '';
  labelRecordatorio5: string = '';
  resultFinal:any;
  flagEnvios_second:any;
  Progenvios:any;
  recordatorio1:any;
  recordatorio2:any;
  recordatorio3:any;
  recordatorio4:any;
  recordatorio5:any;
  recordatorio6:any;
  recordatorio7:any;
  idLanzamiento: string = "";
  show: boolean = true;
  flagEnvios:any;
  TotalDias:any;

  recordatorioPostLanzaV2:any;
  avisosPreLanzaV2:any;
  tipoProgramacionFecha="";
  fechaRecordatorioAnterior:any;

  crearAviso30Dias:boolean=false;
  crearAviso29Dias:boolean=false;
  crearAviso15Dias:boolean=false;
  crearAviso7Dias:boolean=false;
  datosCargados:boolean=false;
 dataSourcefechas2:any;
indiceFechaElegida=0;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalRecoComponent>,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private encuestaService: EncuestaService,
    private sheduleService: SheduleService,
    private surveyServ: SurveyStatusService,
    private programacionService: ProgramacionService,
    private cdRef: ChangeDetectorRef,
    private dateAdapter: DateAdapter<Date>,
    public authService: AuthService,
    private idiomasService: IdiomasService,
    private programacionServiceN35: ProgramacionN35Service,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    console.log('idiomaActual',this.idiomaActual);
    switch (this.idiomaActual) {
      case 'zh1':
        this.idiomaActualDatePicker="zh";
        break;
      case 'zh2':
        this.idiomaActualDatePicker="zh";
        break;
      default:
      this.idiomaActualDatePicker=this.idiomaActual;
        break;
    }


console.log('idiomaActual 2do',this.idiomaActual);

    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang;

      switch (this.idiomaActual) {
        case 'zh1':
          this.idiomaActualDatePicker="zh";
          break;
        case 'zh2':
          this.idiomaActualDatePicker="zh";
          break;

        default:
        this.idiomaActualDatePicker=this.idiomaActual;
          break;
      }


     });
    this.dateAdapter.setLocale(''+this.idiomaActualDatePicker+'');
    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    if(this.userData.level==3 || this.userData.level==2){
      this.nameUserAdmin=this.userData.user;
    }
    else{
      this.nameUserAdmin="";
    }
    }

    lang_shedule.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });

  }

  ngOnInit() {

    console.log(this.data);

    if (this.data.tipo=="recordatorios") {
      this.filtroRecordatorios = (d: Date | null): boolean => {
        var moment = require('moment');
        const diaInicial = moment(this.data.fechaLanzamiento);
        const diaFinal = moment(this.data.fechaLanzamiento).add(21,'days');
        const diaActual = moment(d || new Date());
        return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
      };
    }
    this.city_name = 'TOOLBAR.CITIES.'+''+this.data.instituto;
    this.idiomasService.getNivelNotificacionCatServ(this.data.instituto).subscribe( (data: any) => {
      console.log('entro get catalogo niveles notificaciones',data);
      this.nivelNotificacion=data.catlNotificationBroker[0].secciones.programacion.levelNotification;
      console.log('this.nivelNotificacion::',this.nivelNotificacion);
    });
    //se "oculta" el cierre si es que no se permite editarlo
    if(!this.data.cierreEditable){
      this.fechas[1].visible = false;
    }
    console.log('localStorage',localStorage.getItem('closeNotice'));
    this.closeNotice=JSON.parse(localStorage.getItem('closeNotice'));
    this.selectNotice1=JSON.parse(localStorage.getItem('selectNotice1'));
    this.selectNotice2=JSON.parse(localStorage.getItem('selectNotice2'));
    console.log('this.closeNotice',this.closeNotice);
    console.log('this.selectNotice1',this.selectNotice1);
    console.log('this.selectNotice2',this.selectNotice2);
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.data.instituto);
    if(this.data.tipo == "fechas"){
      this.getFechaLanzamiento35();
    }
    this.horaInstituto = momentTz.tz(this.zonasUTC[this.indiceZona].zona).utc(true);
    this.horaInstitutoTag = momentTz.tz(this.zonasUTC[this.indiceZona].zona);

    this.calculoOffsetPipe();
    this.calculoHoraMinima();
    this.getBanderas();
    this.traduceTextosTS();
    this.dataSourcefechas2=new MatTableDataSource<any>(this.fechas2);
  }

  getBanderas(){
    this.programacionService.getFlagsConfig(localStorage.getItem('productoID')).subscribe((respuesta:any) => {
      console.log("getFlagsConfig:",respuesta);
      if(respuesta.success){
        for(let k in respuesta){
          if(k != "success"){
            this.banderas[k] = respuesta[k];
          }
        }
        console.log("banderas:",this.banderas);
      }
    },error=>{
      console.log(error);
    });
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

  calculoHoraMinima(){
    let horaMinima = this.horaInstituto.clone().add(4,'hours').format('YYYY-MM-DD');
    let horaActual = moment().format('YYYY-MM-DD');
    // console.log("horaMinima:",horaMinima," horaActual:",horaActual);
    let esHoy = moment(horaActual).isSame(horaMinima);
    this.esHoy = esHoy;
    // console.log("es aun hoy?:",esHoy);
  }

  alineaFechaUTC(fecha:string){
    let fechaElegidaAjustada = momentTz.tz(fecha,this.zonasUTC[this.indiceZona].zona).utc(true);
    return fechaElegidaAjustada.format();
  }

  resetFecha() {
    this.input.value = '';
  }

  setOrigen(origen:string){
    this.fechas2.forEach((fecha, i) => {
      if(fecha.tipo === origen){
        this.origen = i;
        this.tipoOrigen = origen;
        switch (origen) {
          case 'lanzamiento': this.rangoLanza(); break;
          case 'recor30': case 'recor29': case 'recor15': case 'recor7':
          this.filtroCalendario = (d: Date | null): boolean => {
            // this.fechaInicialGenerica = new Date(moment().year(), moment().month(), 1);
            let fechaMinima: any;
            if (moment(d).isAfter(moment(this.fechas2[this.origen].fecha).subtract(5,'days')) && moment(d).isBefore(moment(this.fechas2[this.origen].fecha).add(5,'days'))) {
              fechaMinima = true;
            }


            return fechaMinima;
          };
          break;
        }
      }
    });
  }

  setFiltroHoraHoy(hoy:boolean,diaSiguiente?:boolean){
    if(hoy){
      console.log("aplicado filtro de hora para hoy");
      // let horaActualMasCuatro = moment().add(4,'hours');
      let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
      if(horaActualMasCuatro.hours() > 12){
        this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
      }
      else{
        this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
      }
    }
    else{
      if(diaSiguiente){
        console.log("aplicado filtro de hora del dia siguiente a hoy");
        if(this.esHoy){
          this.filtroHoraHoy = "00:00 am";
        }
        else{
          let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
          if(horaActualMasCuatro.hours() > 12){
            this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
          }
          else{
            this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
          }
        }
      }
      else{
        console.log("aplicado filtro de hora para otro dia");
        this.filtroHoraHoy = "00:00 am";
      }
    }

    console.log("filtroHoraHoy:",this.filtroHoraHoy);
  }

  getFechaLanzamiento35(){
        let moment = require('moment');
      this.programacionServiceN35.getDateLanNormv2(localStorage.getItem('productoID')).subscribe((response:any) => {
        console.log('response',response);
        if(response.success){
          if (response.programacion.fechaLanzamiento!=null) {
            this.recordatorioPostLanzaV2=response.programacion.recordatorios;
            this.avisosPreLanzaV2=response.programacion.recordatoriosN35;
            this.fechaLanza = response.programacion.fechaLanzamiento;
            this.fechaCierre = response.programacion.fechaCierre;

            this.fechas2[0].fecha = response.programacion.fechaLanzamiento;
            this.fechas2[0].elegida = true;
            this.fechas2[0].cargando = false;
            this.fechas2[1].fecha = response.programacion.fechaCierre;
            this.fechas2[1].elegida = true;
            this.fechas2[1].cargando = false;
            this.fechas2[1].elegible = true;
            this.fechas2[1].visible = false;
            this.fechas2[1].visibleInstituto = true;

                this.fechas2.splice(2,this.fechas2.length-2);

            if (response.programacion.recordatoriosN35.length>0) {
              response.programacion.recordatoriosN35.sort( (a,b) => { if(a.tipoAviso > b.tipoAviso){ return 1; } else{ return -1; } });
              response.programacion.recordatoriosN35.forEach((tipoAviso,i) => {
            if (tipoAviso.tipoAviso==2) {
              this.fechas2.push({icono: this.iconosAvisos[i].nombre, tipo: "recor30", fecha:tipoAviso.fechaRecordatorio,tipoCorreo:2, hora: "", elegida: true, cargando: false, visible: false, elegible: true,visibleInstituto:true})
            }
            if (tipoAviso.tipoAviso==3) {
              this.fechas2.push({icono: this.iconosAvisos[i].nombre, tipo: "recor29", fecha:tipoAviso.fechaRecordatorio,tipoCorreo:3, hora: "", elegida: true, cargando: false, visible: false, elegible: true,visibleInstituto:true})
            }
            if (tipoAviso.tipoAviso==4) {
              this.fechas2.push({icono: this.iconosAvisos[i].nombre, tipo: "recor15", fecha: tipoAviso.fechaRecordatorio,tipoCorreo:4, hora: "", elegida: true, cargando: false, visible: false, elegible: true,visibleInstituto:true})
            }
            if (tipoAviso.tipoAviso==5) {
              this.fechas2.push({icono: this.iconosAvisos[i].nombre, tipo: "recor7", fecha: tipoAviso.fechaRecordatorio,tipoCorreo:5, hora: "", elegida: true, cargando: false, visible: false, elegible: true,visibleInstituto:true})
            }

});

console.log('this.fechas2.',this.fechas2);
this.dataSourcefechas2 = new MatTableDataSource<any>(this.fechas2);

            }else{
              // this.fechas2.forEach((tipoCorreo,i) => {
              //     if (i>1) {
              //       this.fechas2[i].fecha = "";
              //       this.fechas2[i].elegida = false;
              //       this.fechas2[i].cargando = false;
              //       this.fechas2[i].elegible = false;
              //       this.fechas2[i].visible = false;
              //       this.fechas2[i].visibleInstituto = false;
              //     }
              // });
            }
          } else{
            this.fechas2[0].cargando = false;
            this.fechas2[1].cargando = false;
            this.fechas2[2].cargando = false;
            this.fechas2[3].cargando = false;
            this.fechas2[4].cargando = false;
            this.fechas2[5].cargando = false;
            this.fechas2[6].cargando = false;
          }

        }

        // this.getNormaRecordatoriosFechas();
      }, error => {
        console.log(error);
      });
  }






// +++++++++++++++++++++++++++++++++++++++Nota: Funciones para certificar+++++++++++++++++++++++++++++++++++++

  fechaSeleccionada(event){
    var moment = require('moment');
    let hoy = moment();
    console.log("evento:",event);
    let fechaElegida = event.value;
    let fechaNoce = moment(fechaElegida);
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    let fech=fechaNoce.diff(hoy, 'days')
    console.log('dias de diferencia', fech);
    this.crearAviso30Dias= fech>=30 ? true : false;
    this.crearAviso29Dias=fech<=29 && fech>15 ? true : false;
    this.crearAviso15Dias=fech<=15 && fech>7 ? true : false;
    this.crearAviso7Dias=fech<=7 ? true : false;

    this.fechaAnterior = this.fechas2[this.origen].fecha;
    this.fechas2[this.origen].fecha = fechaMoment;

    // console.log("fechamoment:",fechaMoment," fechaActual:",moment().format('YYYY-MM-DD'));
    if(fechaMoment == moment().format('YYYY-MM-DD')){
      this.setFiltroHoraHoy(true);
    }
    else{
      if(fechaMoment == moment().add(1,'days').format('YYYY-MM-DD')){
        this.setFiltroHoraHoy(false,true);
      }
      else{
        this.setFiltroHoraHoy(false);
      }
    }

    setTimeout(() => {
      if(this.origen == 0){
        console.log("Registra la fecha");
          this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
      }
      else{
        $("#timepicker").click();
      }
    }, 200);
  }


  registraFechaLanzamiento(fecha){
    console.log(fecha);
    let hoy = moment();
    let fechaElegida = moment(fecha);
    console.log("diferencia de dias",fechaElegida.diff(hoy,'days'));

    if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
      if(fechaElegida.diff(hoy,'days') < 30){
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.ERROR3'),
          text: this.translateSrv.instant('SHEDULE.ERROR4'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.tipoProgramacionFecha="menos30Dias";
            $("#timepicker").click();
          }
        });

      }
      else{
        this.tipoProgramacionFecha="mas30Dias";
        $("#timepicker").click();
      }
    }
    else{
      $("#timepicker").click();
    }
  }

  horaSeleccionada(event){
    console.log("horaSel:",event);
    this.fechas2[this.origen].hora = event;
    this.fechas2[this.origen].elegida = true;
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechas2[this.origen].fecha = this.fechas2[this.origen].fecha + " " + hora24;

    // let fechaActual = moment();
    let fechaActual = momentTz.tz(this.zonasUTC[this.indiceZona].zona);

    let fechaActualLocal = moment().utc(true);
    let fechaActualInsti = momentTz.tz(this.zonasUTC[this.indiceZona].zona).utc(true);
    let diferenciaLocalInstituto = fechaActualLocal.diff(fechaActualInsti, 'seconds');
    let fechaElegidaAjustada: any;
    if(diferenciaLocalInstituto < 0){
      fechaElegidaAjustada = momentTz.tz(this.zonasUTC[this.indiceZona].zona).subtract((diferenciaLocalInstituto*-1), 'seconds');
    }
    else{
      fechaElegidaAjustada = momentTz.tz(this.zonasUTC[this.indiceZona].zona).add(diferenciaLocalInstituto, 'seconds');
    }
    let utcActual = moment.utc();
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let fechaSeleccionada = momentTz.tz(this.fechas2[this.origen].fecha,this.zonasUTC[this.indiceZona].zona);
    let diferenciaMinutos = momentTz.tz(this.fechas2[this.origen].fecha,this.zonasUTC[this.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'second'); //se le añade 1 segundo porque siempre se desfasa alv -_-
     let fechaCierre:any;

    console.log('entraron los 21 dias de encuesta ');
    fechaCierre = moment(fechaActualTransformada).set({hour:23,minute:59,second:0,millisecond:0}).add(diferenciaUtc, 'minutes').add(this.zonasUTC[this.indiceZona].diasEncuesta, 'days');

    // console.log("utcActual:",utcActual.format());
    // console.log("fechaActual:",fechaActual.format());
    // console.log("fechaActualLocal:",fechaActualLocal.format());
    // console.log("diferenciaLocalInstituto:",diferenciaLocalInstituto);
    // console.log("fechaElegidaAjustada:",fechaElegidaAjustada.format());
    // console.log("diferenciaUtc:",diferenciaUtc);
    // console.log("fechaSeleccionada:",fechaSeleccionada.format());
    // console.log("diferenciaMinutos:",diferenciaMinutos);
    // console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    //guarda la fecha final ajustada a utc
    this.fechas2[this.origen].fecha = fechaTransformadaMasDifUtc.utc(true).toISOString();
    let aviso30Dias= moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'second').subtract(30, 'days'); // 30 días antes de la encuesta
    let aviso29Dias= moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'second').subtract(29, 'days'); // 30 días antes de la encuesta
    let aviso15Dias= moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'second').subtract(15, 'days');// 15 días antes de la encuesta
    let aviso7Dias= moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'second').subtract(7, 'days');
    console.log('fechaCierre',fechaCierre.utc(true).toISOString());
    console.log('aviso30Dias',aviso30Dias.utc(true).toISOString());
    console.log('aviso15Dias',aviso15Dias.utc(true).toISOString());
    console.log('aviso7Dias',aviso7Dias.utc(true).toISOString());

    switch (this.origen) {
      case 0: this.guardaFechaLanzamiento(fechaTransformadaMasDifUtc.utc(true).toISOString(),fechaCierre.utc(true).toISOString(),aviso30Dias.utc(true).toISOString(),aviso29Dias.utc(true).toISOString(),aviso15Dias.utc(true).toISOString(),aviso7Dias.utc(true).toISOString()); break;
      case 2: case 3:case 4:case 5: this.updateAvisoPosicion(fechaTransformadaMasDifUtc.utc(true).toISOString()); break;

    }

  }

  updateAvisoPosicion(fechaNuevaAviso:any){
let arrAvisos:any[]=[];
console.log('fechaNuevaAviso',fechaNuevaAviso);
console.log('avisosPreLanzaV2',this.avisosPreLanzaV2);
console.log('fechaCierre',this.fechaCierre);
console.log('tipoOrigen',this.tipoOrigen);
let tipo:any;
switch (this.tipoOrigen) {
  case 'recor30': tipo=2;
    break;
  case 'recor29': tipo=3;
    break;
  case 'recor15': tipo=4;
    break;
  case 'recor7': tipo=5;
    break;

  default:
    break;
}
console.log('Origen',this.origen);
let positionFecha=this.avisosPreLanzaV2.findIndex(item=>item.tipoAviso==tipo);
if (positionFecha!=-1) {
  this.avisosPreLanzaV2.splice(positionFecha,1)
}

// this.avisosPreLanzaV2.forEach((fechas,i) => {
//   if (fechas.fechaRecordatorio==this.fechaAnterior) {
//   console.log('si coincide ',fechas.fechaRecordatorio);
//     this.avisosPreLanzaV2.splice(i,1)
//   }
// });

this.avisosPreLanzaV2.push({fechaRecordatorio:fechaNuevaAviso,tipoAviso:tipo});

      let data={
          productoId : localStorage.getItem('productoID'),
          fechaLanzamiento: this.fechaLanza,
          fechaCierre:this.fechaCierre,
          recordatorios:this.recordatorioPostLanzaV2,
          recordatoriosN35:this.avisosPreLanzaV2,
        };

    console.log("datosAGuardar:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVELAUNCHDATE'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    this.programacionServiceN35.registerDateLanNormv2(data).subscribe((respuesta:any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.success){

        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        this.getFechaLanzamiento35();

      }
    }, error => {
      console.log(error);
    });
  }

  guardaFechaLanzamiento(fecha:any,fechaCierre:any,aviso30Dias:any,aviso29Dias:any,aviso15Dias:any,aviso7Dias:any){
let arrAvisos:any[]=[];
this.crearAviso30Dias ? arrAvisos.push({fechaRecordatorio:aviso30Dias,tipoAviso:2},{fechaRecordatorio:aviso29Dias,tipoAviso:3},{fechaRecordatorio:aviso15Dias,tipoAviso:4},{fechaRecordatorio:aviso7Dias,tipoAviso:5}):0;
this.crearAviso29Dias ? arrAvisos.push({fechaRecordatorio:aviso29Dias,tipoAviso:3},{fechaRecordatorio:aviso15Dias,tipoAviso:4},{fechaRecordatorio:aviso7Dias,tipoAviso:5}) :0;
this.crearAviso15Dias ? arrAvisos.push({fechaRecordatorio:aviso15Dias,tipoAviso:4},{fechaRecordatorio:aviso7Dias,tipoAviso:5}):0;
this.crearAviso7Dias ? arrAvisos.push({fechaRecordatorio:aviso7Dias,tipoAviso:5}):0;
console.log('arrAvisos',arrAvisos);
      let data={
          productoId : localStorage.getItem('productoID'),
          fechaLanzamiento: fecha,
          fechaCierre:fechaCierre,
          recordatorios:this.recordatorioPostLanzaV2,
          recordatoriosN35:arrAvisos,
        };

    console.log("datosAGuardar:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVELAUNCHDATE'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    this.programacionServiceN35.registerDateLanNormv2(data).subscribe((respuesta:any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.success){

        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        this.getFechaLanzamiento35();

      }
    }, error => {
      console.log(error);
    });
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  horaAbierta(event){
    console.log("horaAbierta:",event);
  }

  salirSinHora(event){
    console.log("salirSinHora:",event);
    if(this.fechas2[this.origen].hora == ""){
      this.fechas2[this.origen].fecha = this.fechaAnterior;
    }
  }

  rangoLanza(){
    this.filtroCalendario = this.filtroLanzamiento;

  }

  setEnvioCierre(event:any){
    this.banderas.correosCierre = event.checked;
    // console.log("envioCierre:",event.checked);
    this.programacionService.setFlagsConfig(this.banderas, localStorage.getItem('productoID')).subscribe((respuesta:any) => {
      console.log("setFlagsConfig:",respuesta);
      if(respuesta.success){
        this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CHANGECLOSENOT'),this.translateSrv.instant('ALERTS.OK'));
      }
    });
  }



  borraRecordatorio(fecha:string, indice:number){
    console.log();

    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_1') +': \n\n' + moment(fecha).format('DD-MM-YYYY'),
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        //LLAMAR AL SERVICIO QUE LA BORRA EN BACK
        const datosRecoFull = this.data.recordatoriosFullInfoNorma.findIndex(item => item.fechaRecordatorio == fecha);
        console.log('datosRecoFull',datosRecoFull);

        if(datosRecoFull != -1){
          this.data.recordatoriosFullInfoNorma.splice(datosRecoFull,1);
        }
        let data={
          productoId : localStorage.getItem('productoID'),
          fechaLanzamiento:   this.data.fechaLanzamiento,
          fechaCierre:  this.data.fechaCierre,
          recordatorios:this.data.recordatoriosFullInfoNorma,
          recordatoriosN35:this.data.avisosPrelanNorm,
        };
        console.log("datosAGuardar:",data);
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.DELE_RECOR'),
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          }
        });
        this.programacionServiceN35.registerDateLanNormv2(data).subscribe((respuesta:any) => {
            console.log("respGuardaLanz",respuesta);
            if(respuesta.success){
              this.recordatorioBorrado = true;

                Swal.close();
                  this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_2'),this.translateSrv.instant('ALERTS.OK'));
                this.getFechaLanzamiento35();

              }
            }, error => {
                console.log(error);
              });
      }
    });
  }

  salir() {
    let status = true;
    let BreakException = {};
    try {
        this.fechas2.forEach( (fecha,i) => {
          if(i != 2 && i != 3){
            if(!fecha.elegida){
              status = false;
              throw BreakException;
            }
          }
        });
    } catch (e) {
        if (e !== BreakException) throw e;
    };
    this.dialogRef.close({
      status,
      fechaLanzamiento: this.fechaLanza,
      fechaCierre: this.fechas2[1].fecha,
      recordatorioBorrado: this.recordatorioBorrado,
      recordatorioActualizado:this.recordatorioActualizado,
      avisosPreLanzaV2:this.avisosPreLanzaV2,
    });
  }

  enviaOrdenWizardNotificiaciones(){
    // this.wizardService.puenteDatosNotificaciones("100"); //100 = actualiza los status de los steps
    let datos:any={actua:"100",nivelNotif: this.nivelNotificacion}
    this.authService.puenteDatosQuick(datos);
  }

  fechaRecordatorio(origen:number, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');
    if(origen == 2){
      if(this.fechaLanzamiento){
        let arr=[];
        this.data.recordatoriosFullInfoNorma.forEach(element => {
          arr.push(moment(element.fechaRecordatorio).format('MM/DD/YYYY'))
        });
console.log('arr',arr);
        if(!arr.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
          console.log("registra el recordatorio");
          this.guardaRecordatorio(fechaElegida);
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
      }
    }
  }

  guardaRecordatorio(fecha){
    let moment = require('moment');
    this.fechaRecoTemp = moment(fecha).format('YYYY-MM-DD');
    $("#timepickerRecosUpdat").click();

  }

  horaSeleccionadaRecoUpdate(event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaRecoTemp = this.fechaRecoTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.zonasUTC[this.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaRecoTemp,this.zonasUTC[this.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    this.data.recordatoriosFullInfoNorma.forEach((fechaActual,i) => {
      if (fechaActual.fechaRecordatorio==this.fechaRecordatorioAnterior) {
        this.data.recordatoriosFullInfoNorma.splice(i,1);
      }
    });

    this.data.recordatoriosFullInfoNorma.push({fechaRecordatorio:fechaTransformadaMasDifUtc.utc(true).toISOString()})
    let data={
        productoId : localStorage.getItem('productoID'),
        fechaLanzamiento:   this.data.fechaLanzamiento,
        fechaCierre:  this.data.fechaCierre,
        recordatorios:this.data.recordatoriosFullInfoNorma,
        recordatoriosN35:this.data.avisosPrelanNorm,
      };
    console.log("datosRecoNuevo:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.UPDA_RECOR'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.programacionServiceN35.registerDateLanNormv2(data).subscribe((respuesta:any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.success){

        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_2'),this.translateSrv.instant('ALERTS.OK'));
        this.getFechaLanzamiento35();

      }
    }, error => {
      console.log(error);
    });

  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  updRecordatorio(fecha, i){
    console.log('fecha',fecha);
    this.fechaRecordatorioAnterior=fecha.fechaRecordatorio;

this.idRecordatorio=fecha._id;

    if(this.fechaLanzamiento){
      if(this.data.recordatoriosFullInfoNorma.length < this.recordatoriosPermitidos){
        this.calReco2.open();
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }

  getRecordatorios(){
    let data: any = {
      productoId: localStorage.getItem('productoID')
    };
    this.sheduleService.getRecordatorios(data).subscribe((respuesta:any) => {
      console.log("respGetReco",respuesta);
      if(respuesta.message == '200'){
        this.data.recordatoriosFullInfo= respuesta.recordatoriosMostrar;
      }
    }, error => {
      console.log(error);
    });
  }



// +++++++++++++++++++++++++++++++++++++++Nota: Funciones para NORMA V1+++++++++++++++++++++++++++++++++++++

 recordatorio_aviso1(fecha,cantDia){
   // Funcipon que sirve para los 3 primeros avisos
   const mil = 86400000;
   var totalDias =  cantDia * mil;
   var timestamp1 = new Date(fecha).getTime();
   var fianaltotal= (timestamp1 - totalDias);
   var dateprueba = new Date(fianaltotal);
   return dateprueba;
 }

 recordatorio_aviso2(fecha,cantDia){
   // Funcipon que sirve para los ultimos dos avisos
   const mil = 86400000;
   var totalDias =  cantDia * mil;
   var timestamp1 = new Date(fecha).getTime();
   var fianaltotal= (timestamp1 + totalDias);
   var dateprueba = new Date(fianaltotal);
   return dateprueba;
 }
}
